export enum IPCChannel {
    Logout = 'logout'
}